import React from 'react';

import { Loader } from 'components/loader/loader';

import { BreadcrumbsPanel } from './breadcrumbs/grid-upper-panel';
import { AidsListContext } from './context/aids-context';
import { BreadcrumbsContext, useBreadcrumbs } from './context/curmbs-context';

import { ArchivalCollectionsListContext } from './context/archival-collections-context';
import {
  HierarchyContext,
  useAidsHierarchy,
  useCollectionsHierarchy,
} from './context/hierarchy-context';

import { ArchivalAidBody, ArchivalCollectionGridBody } from './grid-body';
import { GridLayout } from './layout/grid-layout';
import { GridLeftPanel } from './grid-left-panel';
import { GridRightPanel } from './grid-right-panel';

const GridWrapper = ({ Body }: { Body: () => JSX.Element }) => {
  const { breadcrumbs } = useBreadcrumbs()();
  return (
    <BreadcrumbsContext.Provider value={breadcrumbs}>
      <GridLayout
        LeftPanel={<GridLeftPanel />}
        BodyPanel={<Body />}
        BreadcrumbsPanel={<BreadcrumbsPanel />}
        RightPanel={breadcrumbs.length > 0 ? <GridRightPanel /> : null}
      />
    </BreadcrumbsContext.Provider>
  );
};

export function ResizableFundsGrid() {
  const { loading, collections, ...rest } = useCollectionsHierarchy();
  if (loading) {
    return <Loader />;
  }
  return (
    <HierarchyContext.Provider value={{ ...rest.hierarchy }}>
      <ArchivalCollectionsListContext.Provider value={{ ...collections }}>
        <GridWrapper Body={ArchivalCollectionGridBody} />
      </ArchivalCollectionsListContext.Provider>
    </HierarchyContext.Provider>
  );
}

export function ResizableAidsGrid() {
  const {
    loading,
    listResult,
    listByOriginatorResult,
    ...rest
  } = useAidsHierarchy();

  if (loading) {
    return <Loader />;
  }

  return (
    <HierarchyContext.Provider value={{ ...rest.hierarchy }}>
      <AidsListContext.Provider value={{ listResult, listByOriginatorResult }}>
        <GridWrapper Body={ArchivalAidBody} />
      </AidsListContext.Provider>
    </HierarchyContext.Provider>
  );
}
